/** @file Grows state.tracks and state.queue so a track index exists (null entry, empty queue). */
import { invariant } from '@pose2d/std/invariant';
import type { AnimState, TrackEntry } from '../contracts/state';
import { BASE_TRACKS } from '../state/baseTracks.data';

/** Base tracks [0, BASE_TRACKS) plus their reserved mirrorFix layers BASE_TRACKS + t (W2-12): 32 tracks. */
const TRACK_LIMIT = 2 * BASE_TRACKS;

/** Pads tracks with null and queue with [] up to `track` (an integer in [0, 32)) and returns that track's queue. */
export function ensureTrack(state: AnimState, track: number): TrackEntry[] {
  invariant(Number.isInteger(track) && track >= 0 && track < TRACK_LIMIT, 'track must be an integer in [0, 2 x BASE_TRACKS): base tracks, then mirrorFix layers BASE_TRACKS + t');
  while (state.tracks.length <= track) state.tracks.push(null);
  while (state.queue.length <= track) state.queue.push([]);
  const queue = state.queue[track];
  invariant(queue !== undefined, 'track queue exists after growth');
  return queue;
}
